import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";

interface LinkItem {
  title: string;
  description: string;
  href: string;
}

interface InternalLinksProps {
  title?: string;
  links: LinkItem[];
}

export const InternalLinks = ({ title = "Related Random Number Tools", links }: InternalLinksProps) => {
  return (
    <section className="my-12 p-6 bg-muted/30 rounded-lg border">
      <h3 className="text-2xl font-bold mb-6">{title}</h3>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {links.map((link, index) => (
          <Link key={index} to={link.href}>
            <Card className="p-4 h-full hover:shadow-lg transition-shadow group cursor-pointer">
              <div className="flex items-start justify-between gap-2">
                <div>
                  <h4 className="font-semibold mb-1 group-hover:text-primary transition-colors">
                    {link.title}
                  </h4>
                  <p className="text-sm text-muted-foreground line-clamp-2">
                    {link.description}
                  </p>
                </div>
                <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0 mt-1" />
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
};
